import { render, staticRenderFns } from "./company_admin_dashboard.vue?vue&type=template&id=1d1b622e&"
import script from "./company_admin_dashboard.vue?vue&type=script&lang=js&"
export * from "./company_admin_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./company_admin_dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports